import React, { useContext, useEffect, useState } from "react";
import intl from "react-intl-universal";
import { mdiClose, mdiCalculator } from "@mdi/js";
import styled from "styled-components";

import calculationRest from "../../../rest/calculationRest";
import worstcaseDataRest from "../../../rest/worstcaseDataRest";

import { useInput } from "../../hooks/useInput";
import { EntryContext } from "../../contexts/EntryContext";

import { Grid } from "../../components/Grid";
import { Dialog } from "../../containers/Dialog";
import { Button } from "../../components/Button";
import { Spacer } from "../../components/Spacer";
import { DialogBody } from "../../containers/DialogBody";
import { InputNumber } from "../../components/InputNumber";
import { DialogFooter } from "../../containers/DialogFooter";
import { SelectSingle } from "../../components/SelectSingle";
import { Checkbox } from "../../components/Checkbox";

const SpacerStyle = styled.div`
    height: 130px;
    width: 100%;
`;

export const OverviewDialog = props => {

    const entryContext = useContext(EntryContext);

    const [isFarfieldDataAvailable, setFarfieldDataAvailable] = useState(false);
    const isOverviewWorstcase = useInput("isOverviewWorstcase", false);
    const overviewFieldType = useInput("fieldType", "PROTECTION_AREA_BLMSCHV");
    const overviewFieldLimit = useInput("fieldLimit", null);

    useEffect(() => {
        (async () => {
            const isFarfieldAvailable = await worstcaseDataRest.isAvailable(entryContext.entry.id, true);
            setFarfieldDataAvailable(isFarfieldAvailable);
        })();
    }, [entryContext.entry.id, isOverviewWorstcase.value]);

    useEffect(() => {
        if (isOverviewWorstcase.value && !["PROTECTION_AREA_BLMSCHV", "EXHAUSTION_FACTOR_BLMSCHV"].includes(overviewFieldType.value)) {
            overviewFieldType.set("PROTECTION_AREA_BLMSCHV");
            overviewFieldLimit.set(null);
        }
    }, [isOverviewWorstcase.value]);

    const onOverview = async () => {
        if (isOverviewWorstcase.value && !isFarfieldDataAvailable) {
            return;
        }
        const { entry } = entryContext;
        entry.overviewSetting = {
            ...entry.overviewSetting,
            fieldType: overviewFieldType.value,
            fieldLimit: overviewFieldType.value === "PROTECTION_AREA_BLMSCHV" ? null : overviewFieldLimit.value,
            useWorstcaseData: isOverviewWorstcase.value,
        };
        await props.saveEntry(entry);
        let updatedEntry;
        if (isOverviewWorstcase.value) {
            updatedEntry = await calculationRest.overviewWorstcase(entry.id);
        } else {
            updatedEntry = await calculationRest.overview(entry.id);
        }
        entryContext.setEntry(updatedEntry);
        props.onClose();
    };

    return (
        <Dialog
            width="430px"
            title={intl.get("entry.overview")}
            onClose={() => props.onClose()}>
            <DialogBody>
                <Grid columns="1">
                    <SelectSingle {...overviewFieldType.bind}
                        title={intl.get("entry.overviewSetting.fieldType")}
                        toLabel={value => intl.get("enum.fieldType." + value)}>
                        {!isOverviewWorstcase.value && <option value="E_FIELD" >{intl.get("enum.fieldType.E_FIELD")}</option>}
                        {!isOverviewWorstcase.value && <option value="H_FIELD">{intl.get("enum.fieldType.H_FIELD")}</option>}
                        <option value="PROTECTION_AREA_BLMSCHV">{intl.get("enum.fieldType.PROTECTION_AREA_BLMSCHV")}</option>
                        {!isOverviewWorstcase.value && <option value="PROTECTION_AREA_EXP_1">{intl.get("enum.fieldType.PROTECTION_AREA_EXP_1")}</option>}
                        <option value="EXHAUSTION_FACTOR_BLMSCHV">{intl.get("enum.fieldType.EXHAUSTION_FACTOR_BLMSCHV")}</option>
                        {!isOverviewWorstcase.value && <option value="EXHAUSTION_FACTOR_EXP_1">{intl.get("enum.fieldType.EXHAUSTION_FACTOR_EXP_1")}</option>}
                    </SelectSingle>
                    <InputNumber {...overviewFieldLimit.bind}
                        fractionDigits={4}
                        disabled={overviewFieldType.value === "PROTECTION_AREA_BLMSCHV"}
                        title={intl.get("entry.overviewSetting.fieldLimit")} />
                    <Checkbox
                        {...isOverviewWorstcase.bind}
                        title={intl.get("entry.worstcase")} />
                    <SpacerStyle />
                </Grid>
            </DialogBody>
            <DialogFooter>
                <Button
                    svgIcon={mdiClose}
                    onClick={() => props.onClose()}
                    value={intl.get("common.cancel")} />
                <Spacer variant="vertical" />
                <Button
                    disabled={isOverviewWorstcase.value && !isFarfieldDataAvailable}
                    svgIcon={mdiCalculator}
                    onClick={onOverview}
                    value={intl.get("entry.calculate")} />
            </DialogFooter>
        </Dialog>
    );
};